export const env = {
  OIDC_CLIENT_ID: process.env.REACT_APP_OIDC_CLIENT_ID as string,
  OIDC_ISSUER_URL: process.env.REACT_APP_OIDC_ISSUER_URL as string,
  VC_API_URL: process.env.REACT_APP_VC_API_URL as string
};
